<div *ngIf="showIframe" class="app-pdf-file-view-component">
    <a (click)="showIframe=false;isLoadIframe=false;_previewUrl=''" class="btn-close">
        <mat-icon>close</mat-icon>
    </a>
    <iframe *ngIf="_previewUrl" class="border" [src]="_previewUrl" id="dialog-frame"></iframe>
</div>